<template>
  <div class="full-bleed-container">
    <div class="app-content-column">
      <div class="flex-row">
        <div class="flex-row left-row">
          <div class="flex-column">
            <span class="bold-heading">About us</span>
            <router-link :to="{ name: 'About' }" @click.native="toTop">
              Our vision and values
            </router-link>
            <!-- <a href="" target="_blank">Read our blog</a> -->
            <router-link :to="{ name: 'About' }" @click.native="toTop">Meet our team</router-link>
            <!-- <router-link :to="{ name: 'FAQ' }" @click.native="toTop">FAQ</router-link> -->
          </div>

          <div class="flex-column">
            <span class="bold-heading">Get involved</span>
            <router-link
              v-if="!userIsLoggedIn"
              :to="{ name: 'UserOnboarding' }"
              @click.native="toTop"
            >
              Sign up
            </router-link>
            <router-link :to="{ name: 'ListEvents' }">Events</router-link>
            <div class="speak-list">
              <span>Speak out:</span>
              <span>Call at <a href="tel:+254722235663">+254 722 235 663</a></span>
              <span>Call at <a href="tel:+254722263722">+254 722 263 722</a></span>
              <span>
                Write to <a href="mailto:mzingopartners@gmail.com">mzingopartners@gmail.com</a>
              </span>
            </div>
            <router-link
              :to="{
                name: 'Contacts',
                hash: '#feedback-form',
                query: { subject: 'I want to get involved' },
              }"
              @click.native="toTop"
            >
              Organize
            </router-link>
          </div>
        </div>

        <div class="flex-row right-row">
          <div class="flex-column">
            <span class="bold-heading">Connect with us</span>
            <div class="share-wrapper">
              <a href="https://twitter.com/mzingo_partners" target="_blank">
                <font-awesome-icon size="2x" :icon="['fab', 'twitter']" />
              </a>
              <a href="https://www.facebook.com/mzingopartners/" target="_blank">
                <font-awesome-icon size="2x" :icon="['fab', 'facebook']" />
              </a>
              <a href="https://www.linkedin.com/company/mzingo/" target="_blank">
                <font-awesome-icon size="2x" :icon="['fab', 'linkedin']" />
              </a>
              <a href="https://www.instagram.com/mzingo_partners/" target="_blank">
                <font-awesome-icon size="2x" :icon="['fab', 'instagram']" />
              </a>
            </div>
            <router-link :to="{ name: 'Contacts' }" @click.native="toTop">Contact us</router-link>
            <router-link
              :to="{
                name: 'Contacts',
                hash: '#feedback-form',
                query: { subject: 'I want to report a concern' },
              }"
              @click.native="toTop"
            >
              Report a concern
            </router-link>
            <router-link :to="{ name: 'Legal' }" @click.native="toTop">Legal notice</router-link>
          </div>
        </div>
      </div>
      <div class="copyright-container">
        <span>2020 &copy; Mzingo Partners LTD</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapGetters(['userIsLoggedIn']),
  },
  methods: {
    // used as workaround along with @click.native on router link
    // to scroll to top or hash on same route
    // https://github.com/vuejs/vue-router/issues/1155
    toTop() {
      const hash = this.$route.hash

      if (hash) {
        const el = document.getElementById(hash.substring(1))
        el.scrollIntoView()
      } else {
        window.scrollTo(0, 0)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.full-bleed-container {
  display: flex;
  flex-shrink: 0; // sticky footer hack

  background-color: $primary;
  color: white;
}

.flex-row {
  display: flex;

  @media screen and (max-width: 900px) {
    max-width: 600px;
    margin: 0 auto;
  }

  @media screen and (max-width: 560px) {
    flex-direction: column;
    margin: 0;
  }
}

.left-row {
  justify-content: space-between;
  flex-grow: 2;

  @media screen and (max-width: 899px) {
    flex-grow: 3;
    flex-direction: column;
    justify-content: flex-start;
  }
}

.right-row {
  justify-content: flex-end;
  flex-grow: 1;

  @media screen and (max-width: 899px) {
    flex-grow: 2;
    flex-direction: column;
    justify-content: flex-start;
  }
}

.flex-column {
  display: flex;
  flex-direction: column;

  padding: 2em 1.5em;

  & > * {
    padding: 0.35em;
  }

  .bold-heading {
    padding-bottom: 1em;
    font-weight: 900;
    font-size: 22px;
  }
}

.speak-list {
  display: flex;
  flex-direction: column;
  padding: 0;

  & > * {
    padding: 0.35em;

    &:not(:first-child) {
      padding-left: 1.5em;
    }
  }
}

.share-wrapper {
  display: flex;
  padding-bottom: 1em;

  & > *:not(:last-child) {
    margin-right: 1.5em;
  }
}

a {
  color: white;
}

.copyright-container {
  padding: 1em;
  text-align: center;
}
</style>
